module.exports = __webpack_public_path__ + "static/media/pay-2.1fd544b5.svg";